import { gql } from '@urql/core';
import { createQueryKeys } from '@lukemorales/query-key-factory';

export const funnelsFeatureKeys = createQueryKeys('funnelFeature', {
  funnelList: ({ siteId, limit, field, sort, search }) => [
    {
      siteId,
      limit,
      order: {
        field,
        sort,
      },
      search,
    },
  ],
  funnelDetail: ({ id }) => [
    {
      id,
    },
  ],
  funnelsUsingGoals: ({ siteId, goalIds }) => [
    {
      siteId,
      goalIds,
    },
  ],
  funnelResult: ({ siteId, startAt, endAt, timeUnit, steps, filters }) => [
    {
      siteId,
      startAt,
      endAt,
      timeUnit,
      steps,
      filters,
    },
  ],
  funnelResult2: ({ siteId, startAt, endAt, timeUnit, steps }) => [
    {
      siteId,
      startAt,
      endAt,
      timeUnit,
      steps,
    },
  ],
});

export const funnelResultQuery = ({ siteId, startAt, endAt, timeUnit, steps, filters }) => ({
  ...funnelsFeatureKeys.funnelResult({ siteId, startAt, endAt, timeUnit, steps, filters }),
  meta: {
    query: gql`
      query FunnelResult(
        $siteId: Int!
        $startAt: Int!
        $endAt: Int!
        $timeUnit: Int!
        $steps: [FunnelStep!]!
        $filters: FunnelFilter
      ) {
        funnelResult(
          siteId: $siteId
          startAt: $startAt
          endAt: $endAt
          timeUnit: $timeUnit
          steps: $steps
          filters: $filters
        ) {
          summary
          timeUnitResults {
            startAt
            endAt
            steps
            conversionRates
          }
        }
      }
    `,
  },
});

export const funnelResultQuery2 = ({ siteId, startAt, endAt, timeUnit, steps }) => ({
  ...funnelsFeatureKeys.funnelResult2({ siteId, startAt, endAt, timeUnit, steps }),
  meta: {
    query: gql`
      query FunnelResultNew($siteId: Int!, $startAt: Int!, $endAt: Int!, $timeUnit: Int!, $steps: [FunnelStep!]!) {
        funnelResultNew(siteId: $siteId, startAt: $startAt, endAt: $endAt, timeUnit: $timeUnit, steps: $steps) {
          summary
        }
      }
    `,
  },
});

export const funnelFragment = gql`
  fragment funnel on Funnel {
    createdAt
    createdBy {
      name
    }
    id
    name
    visitStep
    goalSteps {
      id
      name
      autoName
      display_data
    }
    siteId
  }
`;

export const funnelListQuery = ({ siteId, limit, field, sort, search }) => ({
  ...funnelsFeatureKeys.funnelList({ siteId, limit, field, sort, search }),
  meta: {
    query: gql`
      query FunnelList($siteId: Int, $cursor: String, $limit: Int, $order: FunnelListOrder, $search: String) {
        funnelList(siteId: $siteId, cursor: $cursor, limit: $limit, order: $order, search: $search) {
          hasNextPage
          nextPageCursor
          funnels {
            ...funnel
          }
        }
      }
      ${funnelFragment}
    `,
  },
});

export const funnelDetailQuery = ({ id }) => ({
  ...funnelsFeatureKeys.funnelDetail({ id }),
  meta: {
    query: gql`
      query FunnelDetail($id: Int!) {
        funnelDetail(id: $id) {
          ...funnel
        }
      }
      ${funnelFragment}
    `,
  },
});

export const funnelsUsingGoalsQuery = ({ siteId, goalIds }) => ({
  ...funnelsFeatureKeys.funnelsUsingGoals({ siteId, goalIds }),
  staleTime: 0,
  refetchOnWindowFocus: true,
  meta: {
    query: gql`
      query FunnelsUsingGoals($siteId: Int!, $goalIds: [Int!]!) {
        funnelsUsingGoals(siteId: $siteId, goalIds: $goalIds) {
          ...funnel
        }
      }
      ${funnelFragment}
    `,
  },
});
